import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function GuaranteeSection() {
  return <section className="bg-brand-green py-10 md:py-12" data-id="element-148">
      <div className="max-w-3xl mx-auto px-4 text-center" data-id="element-149">
        <FadeIn data-id="element-150">
          <div className="text-6xl md:text-7xl mb-6" data-id="element-151">🛡️</div>
          <h2 className="text-3xl md:text-4xl font-bold text-brand-brown mb-8" data-id="element-152">
            Garantía Total de 7 Días
          </h2>
          <p className="text-lg md:text-xl text-brand-brown/80 leading-relaxed" data-id="element-153">
            Si seguís el método paso a paso y no quedás conforme con el
            resultado, te devolvemos el 100% de tu dinero. Sin preguntas. Sin
            vueltas.
          </p>
        </FadeIn>
      </div>
    </section>;
}